import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { readerGoogle, errorDetail } from "@/lib/reader";

export default function ReaderAuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    readerGoogle(sessionId)
      .then(() => toast.success("Signed in with Google."))
      .catch((e) => toast.error(errorDetail(e)))
      .finally(() => navigate("/reader", { replace: true }));
  }, [location.hash, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="reader-auth-callback">
      <Loader2 className="w-8 h-8 text-primary-gold animate-spin" />
    </div>
  );
}
